export function getAccount(state) {
  return state.account;
}



// WEBPACK FOOTER //
// ./src/views/account/_selectors.js